import type {ReactNode, Ref, RefObject} from 'react';
import {Popover as PopoverPrimitive} from 'radix-ui';
import {Popover, PopoverContent} from '@/components/ui/popover';
export function SearchPopover({
  children,
  className,
  ref,
  anchorRef,
  open,
  onOpenChange,
}: {
  children?: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
  anchorRef: RefObject<HTMLElement | null>;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Popover open={open} onOpenChange={onOpenChange} modal={false}>
      <PopoverPrimitive.Anchor
        virtualRef={{
          current: {getBoundingClientRect: () => anchorRef.current?.getBoundingClientRect() ?? new DOMRect()},
        }}
      />
      <PopoverContent
        ref={ref}
        align="start"
        sideOffset={4}
        style={{width: anchorRef.current?.getBoundingClientRect().width}}
        className={className}
        onOpenAutoFocus={(event) => event.preventDefault()}
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
